import {RequestOptions, Headers} from '@angular/http';
export class BaseService {
api_key = "8E692A68461AD4A52774D1648BC17";
  constructor() {
  }

  public jwt(can_user_auth_key = false):RequestOptions {
    // create authorization header with jwt token
    if (can_user_auth_key) {
      let headers = new Headers();
       headers.append("Authorization", this.api_key);
       headers.append("Content-type", "application/json");
       let options = new RequestOptions({ headers: headers });
      return options;
    } else {
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));

      if (currentUser && currentUser.token) {
        let headers = new Headers({'Authorization': 'Bearer ' + currentUser.token});
        return new RequestOptions({headers: headers});
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/BaseService.ts